<template>
  <div class="news-bread">
    <!-- 面包屑 -->
    <shBread>
      <shBreadItem to="/">首页</shBreadItem>
      <shBreadItem to="/books">图书</shBreadItem>
      <shBreadItem
        ><div class="bread">{{ booksDetail[0]?.booksTitle }}</div></shBreadItem
      >
    </shBread>
  </div>

  <div class="book-detail">
    <div class="book-desc">
      <BookImg :booksImg="booksImg" />
      <BookDetail :booksDetail="booksDetail" />
    </div>
  </div>
  <div class="container">
    <div class="con-left">
      <BookDesc :booksDetail="booksDetail" />
    </div>
    <div class="con-right">
      <videoRecommend :VideoReCommend="VideoReCommend" />
    </div>
  </div>
</template>

<script>
//import ShCity from "../../components/library/sh-city.vue";
import { findbooksDetail } from "@/api/books";
import { findVideoRecommand } from "@/api/video";
import BookImg from "./components/book-img.vue";
import videoRecommend from "../../components/video-recommend.vue";
import BookDetail from "./components/book-detail.vue";
import BookDesc from "./components/book-desc.vue";
import { ref } from "vue";
import { useRoute } from "vue-router";
export default {
  components: { BookImg, videoRecommend, BookDetail, BookDesc },

  setup(props) {
    const route = useRoute();

    const booksImg = ref([]);
    const booksDetail = ref([]);
    const VideoReCommend = ref([]);
    const booksNum = ref(1);
    findbooksDetail(route.query.id)
      .then((data) => {
        booksDetail.value = data.map((item) => {
          return {
            booksAuthor: item.booksAuthor,
            booksPrice: item.booksPrice,
            salePrice: item.salePrice * booksNum.value,
            booksTitle: item.booksTitle,
            press: item.press,
            pressDate: item.pressDate,
            pressISBN: item.pressISBN,
            id: item._id,
            examline: item.examline,
            advice: item.advice,
            descImgs: item.descImgs.map((vtem) => {
              return {
                name: vtem.name,
                url: "/web/" + vtem.url,
              };
            }),
          };
        });

        booksImg.value = data[0].mainImgs.map((item) => {
          return {
            name: item.name,
            url: "/web/" + item.url,
          };
        });
      })
      .catch((error) => {
        console.log(error);
      });
    //获取视频推荐

    findVideoRecommand(route.query.clID.split(","))
      .then((data) => {
        VideoReCommend.value = data.map((item) => {
          return {
            chID: item.chID,
            maID: item.maID,
            coID: item.coID,
            clID: item.clID,
            leName: item.leName,
            leImg: "/web/" + item.leImg,
            coverImg: "/web/" + item.coverImg,
            grade: item.grade.find((ele) => ele._id == item.gradeID),
            id: item._id,
          };
        });
      })
      .catch((error) => {
        console.log(error);
      });

    return {
      BookDesc,
      BookDetail,
      BookImg,
      booksDetail,
      booksImg,
      VideoReCommend,
    };
  },
};
</script>

<style lang="less" scoped>
.news-bread {
  background: @shColor;
  .bread {
    width: 700px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  //margin-bottom: 15px;
}
.book-detail {
  margin: 0 auto;
  width: 1240px;
  //height: 1200px;
  //background: #999;
  .book-desc {
    height: 520px;
    background: #fff;
    display: flex;
    //justify-content: space-around;
  }
}
.container {
  margin: 50px auto;
  width: 1240px;
  //height: 1000px;
  display: flex;
  justify-content: space-between;
  //background: #fff;
  .con-left {
    width: 850px;
    background: #fff;
  }
  .con-right {
    width: 350px;
    //background: #fff;
  }
}
</style>
